module.exports = __webpack_public_path__ + "static/img/boom.f6b99dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/year/boom.png
// module id = 9c3c
// module chunks = 1